<template>
  <v-dialog v-model="showModal" width="400" @click:outside="closeDialog">
    <v-card max-width="400">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="text-h5 text-medium-emphasis ps-2 title-text">link cash account</div>
        <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
      </v-card-title>
      <v-divider class="mb-4"></v-divider>
      <v-card-text>
        <v-sheet class="mx-auto" width="300">
          <p class="body-text mb-4">{{ brokerAccountName }}</p>
          <v-select
            label="linked cash account"
            variant="underlined"
            class="form_field"
            v-model="selectedCashAccountId"
            :items="cashAccountOptions"
            item-title="label"
            item-value="value"
            clearable
          ></v-select>
        </v-sheet>
      </v-card-text>
      <template v-slot:actions>
        <v-row align="center" justify="end" class="actionsRow">
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" block>save</v-btn>
        </v-row>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    show: Boolean,
    brokerAccountId: Number,
  },
  data() {
    return {
      brokerAccountName: '',
      selectedCashAccountId: null,
      cashAccounts: [],
    };
  },
  computed: {
    ...mapState({
      token: 'token',
    }),
    showModal: {
      get() {
        return this.show;
      },
    },
    cashAccountOptions() {
      return this.cashAccounts.map(ca => ({
        label: `${ca.account_name} (${ca.bank})`,
        value: ca.id,
      }));
    },
  },
  methods: {
    ...mapMutations(['showSnackbar']),
    async loadData() {
      if (!this.brokerAccountId) return;
      try {
        const [brokerRes, cashRes] = await Promise.all([
          axios.get(`/securities/brokeraccounts/${this.brokerAccountId}`, { headers: { Authorization: `Bearer ${this.token}` } }),
          axios.get('/cashaccounts/', { headers: { Authorization: `Bearer ${this.token}` } }),
        ]);
        this.brokerAccountName = brokerRes.data.account_name;
        this.selectedCashAccountId = brokerRes.data.cash_account_id ?? null;
        this.cashAccounts = cashRes.data.cash_accounts;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load data' });
      }
    },
    async submitForm() {
      try {
        await axios.put(`/securities/brokeraccounts/${this.brokerAccountId}`, {
          cash_account_id: this.selectedCashAccountId ?? null,
        }, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.$emit('close');
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update broker account' });
      }
    },
    closeDialog() {
      this.$emit('close');
    },
  },
  watch: {
    show(newVal) {
      if (newVal) this.loadData();
    },
  },
};
</script>

<style scoped>
.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.actionsRow {
  margin-bottom: 5px;
}
</style>
